import classNames from "classnames";
import style from "./ShareButton.module.scss";
import PropTypes from "prop-types";

const ShareModal = ({ position, urlToShare, copied, onClose, onCopy }) => {
  const iconCopy = classNames("tg-icons-Copy", "iconSize");

  return (
    <div className={style.shareModal} style={{ top: position.top }} role="dialog" aria-modal={true}>
      <button type="button" aria-label="Close" className={style.closeButton} onClick={onClose}>
        <i className="tg-icons-Cross"></i>
      </button>
      <p className={style.label}>Share link</p>
      <div className={style.inputContainer}>
        <input type="text" readOnly value={urlToShare} className={style.textToCopy} />
        <button className={style.copyButton} onClick={onCopy} aria-label="Copy to clipboard">
          <i className={iconCopy} />
          {copied ? "Copied!" : "Copy Link"}
        </button>
      </div>
    </div>
  );
};

ShareModal.propTypes = {
  position: PropTypes.object.isRequired,
  urlToShare: PropTypes.string.isRequired,
  copied: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
};

export default ShareModal;
